module.exports = __webpack_public_path__ + "img/DJ.92f1a075.svg";